module.exports = __webpack_public_path__ + "img/onedaydiary.d3612042.png";